"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromBase64Url = void 0;
const createFromBase64_1 = require("./createFromBase64");
exports.fromBase64Url = (0, createFromBase64_1.createFromBase64)('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_', true);
